import { createTheme } from '@material-ui/core'
import './fonts/poppins.css'

import blueGrey from '@material-ui/core/colors/blueGrey'
import 'typeface-roboto'

export const themeDark = createTheme({
  palette: {
    primary: {
      light: '#549fdd',
      main: '#549fdd',
      dark: '#19507e',
      contrastText: '#fff',
    },
    secondary: {
      light: '#549fdd',
      main: '#549fdd',
      dark: '#19507e',
      contrastText: '#fff',
    },
    danger: {
      light: '#ffebee',
      main: '#e84118',
    },
  },
  typography: {
    fontSize: 14,
    color: 'red',
    useNextVariants: true,
    fontFamily: 'Roboto',
    h4: {
      color: '#fff',
      fontWeight: 'bold',
    },
    body1: {
      fontSize: 14,
      //color: '#fff'
    },
  },
  icon: 'themeDark',
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(255, 255, 255, 0.25) transparent',
        },
        '*::-webkit-scrollbar': {
          width: 6,
          height: 6,
        },
        '*::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(255, 255, 255, 0.25)',
          borderRadius: 8,
        },
        '*::-webkit-scrollbar-thumb:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.4)',
        },
      },
    },
  },
  gray1Color: blueGrey[700],
  gray2Color: blueGrey[800],
  blackColor: blueGrey[900],
  snackbarSuccess: '#BB86FC',
})
